import { Pipe, PipeTransform } from '@angular/core';
import { PageEditMode } from '../utils/page-edit-modes/page-edit-mode';
import { RectPageEditMode } from '../utils/page-edit-modes/rect-page-edit-mode';
import { SelectionPageEditMode } from '../utils/page-edit-modes/selection-page-edit-mode';
import { DrawEditMode } from '../utils/page-edit-modes/draw-edit-mode';
import { CopyingPageEditMode } from '../utils/page-edit-modes/copying-page-edit-mode';
import { WhiteboardEditMode } from '../utils/page-edit-modes/whiteboard-edit-mode';
import { HomeworkEditMode } from '../utils/page-edit-modes/homework-edit-mode';
import { TestEditMode } from '../utils/page-edit-modes/test-edit-mode';

@Pipe({
    name: 'pageEditModeName',
    standalone: true
})
export class PageEditModeNamePipe implements PipeTransform {

    transform(pageEditMode: PageEditMode, args?: any): any {

        if (pageEditMode instanceof RectPageEditMode) {
            return 'Notiz erstellen';
        }

        if (pageEditMode instanceof SelectionPageEditMode) {
            return 'Text markieren';
        }

        if (pageEditMode instanceof CopyingPageEditMode) {
            return 'Text kopieren';
        }

        if (pageEditMode instanceof DrawEditMode) {
            return 'Zeichnen';
        }

        if (pageEditMode instanceof WhiteboardEditMode) {
            return 'Tafelbilder verlinken';
        }

        if (pageEditMode instanceof HomeworkEditMode) {
            return 'Hausaufgaben bearbeiten';
        }

        if (pageEditMode instanceof TestEditMode) {
            return 'Test bearbeiten';
        }

        return '';
    }

}
